export default "* Hvad tror I egernet er rigtig god til med sin krop?\n* Hvad tror I er blandt egernets livretter?\n* Hvad kendetegner et pattedyr?";